import { useNavigate } from 'react-router-dom';
import Url from '../../../data/url';
import TopHeaderWithPrev from '../../../component/common/TopHeaderWithPrev';
import FullHeightContainer from '../../../component/common/FullHeightContainer';
import { useTranslation } from '../../../hook/useTranslation';

function CompanyInfoPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev title={t('my.company_info')} onClickPrev={() => navigate(Url.My)} />
      <div className="pageInner bg-[#FFF]">
        <div className="text-[18px] text-[#363636] w-full text-left font-[700] my-[20px]">
          {t('my.company.name')}
        </div>
        <div className="w-full flex flex-col justify-start items-start my-[20px] grow overflow-y-auto gap-[12px]">
          <div className="text-[14px] text-[#363636] w-full text-left font-[400]">
            {t('my.company.ceo')}
          </div>
          <div className="text-[14px] text-[#363636] w-full text-left font-[400]">
            {t('my.company.business_number')}
          </div>
          <div className="text-[14px] text-[#363636] w-full text-left font-[400] break-keep">
            {t('my.company.address')}
          </div>
        </div>
      </div>
    </FullHeightContainer>
  );
}

export default CompanyInfoPage;
